import { BacklogAuthRequestResolver as BacklogAuthRequestResolverImple } from "../api/BacklogAuthRequestResolver";
import { BacklogDataValidator as BacklogDataValidatorImple } from "../api/BacklogDataValidator";
import { BacklogHttpResponse as BacklogHttpResponseImple } from "../api/BacklogHttpResponse";
import { BacklogRequest as BacklogRequestImple } from "../api/BacklogRequest";
import type { BacklogDataValidator as BacklogDataValidatorContract } from "../contracts/api/BacklogDataValidator";
import type { BacklogHttpResponse as BacklogHttpResponseContract } from "../contracts/api/BacklogHttpResponse";
import type { BacklogRequest as BacklogRequestContract } from "../contracts/api/BacklogRequest";
import type { BacklogRequestResolver as BacklogRequestResolverContract } from "../contracts/api/BacklogRequestResolver";
import type { BacklogHttpFetcher as BacklogHttpFetcherContract } from "../contracts/utils/BacklogHttpFetcher";
import type { BacklogMetadata as BacklogMetadataContract } from "../contracts/utils/metadata/BacklogMetadata";
import { BacklogHttpFetcher as BacklogHttpFetcherImple } from "./BacklogHttpFetcher";
import { resolveBacklogContainer } from "./BacklogUtil";
import type {
	BacklogDIContainer,
	BacklogDependenciesType,
} from "./di/BacklogDIContainer";
import { BacklogMetadata as BacklogMetadataImple } from "./metadata/BacklogMetadata";

export type BacklogClassName =
	| "BacklogDataValidator"
	| "BacklogHttpFetcher"
	| "BacklogHttpResponse"
	| "BacklogMetadata"
	| "BacklogRequest"
	| "BacklogRequestResolver";

export type BindSignature = {
	<T extends object>(
		className: "BacklogDataValidator",
		dependencies?: object,
	): BacklogDataValidatorContract<T>;
	(
		className: "BacklogHttpFetcher",
		dependencies?: object,
	): BacklogHttpFetcherContract;
	(
		className: "BacklogHttpResponse",
		dependencies?: object,
	): BacklogHttpResponseContract;
	(
		className: "BacklogRequestResolver",
		dependencies?: object,
	): BacklogRequestResolverContract;
	(className: "BacklogRequest", dependencies?: object): BacklogRequestContract;
	<T>(
		className: "BacklogMetadata",
		dependencies?: object,
	): BacklogMetadataContract<T>;
};

export function initBacklogService(container: BacklogDIContainer) {
	bind(container, "BacklogDataValidator", BacklogDataValidatorImple);
	bind(container, "BacklogHttpFetcher", BacklogHttpFetcherImple);
	bind(container, "BacklogHttpResponse", BacklogHttpResponseImple);
	bind(container, "BacklogMetadata", BacklogMetadataImple);
	bind(container, "BacklogRequest", BacklogRequestImple, {
		// request_resolver: () => container.resolve("BacklogRequestResolver"),
		fetcher: () => resolveBacklogContainer("BacklogHttpFetcher"),
	});
	bind(container, "BacklogRequestResolver", BacklogAuthRequestResolverImple);
}

function bind(
	container: BacklogDIContainer,
	className: BacklogClassName,
	classRef: unknown,
	dependencies?: BacklogDependenciesType,
) {
	container.bind(className, classRef, dependencies);
}
